<template>
  <div class="bqgl">
    <div class="left">
      <myTitleName titleName="标签体系"></myTitleName>
      <div class="searchInput">
        <el-input placeholder="请输入" v-model="typeName" clearable @input="typeSearch">
          <img slot="prefix" class="el-input__icon"  src="@/assets/images/searchIcon.png" alt="">
        </el-input>
        <el-button type="primary" @click="labelTypeAdd">新增</el-button>
      </div>
      <el-tree class="labelTree" :data="labelType" :props="defaultProps" @node-click="nodeClick" :highlight-current="true" :expand-on-click-node="false">
        <template #default="{node,data}">
          <div class="custom-tree-node">
            <div class="customTreeNodeLeft" >
              <!-- 第一级固定一个图标 -->
              <img src="@/assets/images/xtwh/bqgl/icon-tree.png" v-if="node.level === 1" class="iconTree" />
              <span  :class="node.level === 1 ? 'oneLevel' : 'otherLevel'">{{ node.label }}</span>
            </div>
            <div class="customTreeNodeRight" >
              <el-popover
                placement="right"
                title=""
                width="160"
                trigger="hover"
                popper-class="labelPopover"
                :offset="-30">
                <div class="moreOperate">
                  <div class="treeMoreOperateItem" @click.stop="labelTypeEdit(data)">
                      <img src="@/assets/images/labelEdit.png" alt="">
                      <span>编辑</span>
                  </div>
                  <div class="treeMoreOperateItem" @click.stop="labelTypeDel(data)">
                      <img src="@/assets/images/labelDel.png" alt="">
                      <span>删除</span>
                  </div>
                </div>
                <i slot="reference" class="el-icon-more"></i>
              </el-popover>
            </div>
          </div>
        </template>
      </el-tree>
    </div>
    <div class="right">
      <myTitleName titleName="标签数据" style="margin-bottom: 16px;"></myTitleName>
      <myTableSearch :isOperate="true" :queryFn="getList"  ref="myTableSearch" :operateWidth="124" :formData="formData" :tableLabel="tableLabel">
        <template slot="tool">
          <div class="flex flex-x toolBtn">
            <el-button type="primary" @click="labelDataAdd" style="background-color:rgba(12, 123, 242, 1);">
              新增数据
              <img src="@/assets/images/xzsj.png" alt="">
            </el-button>
            <el-button class="otherBtn" @click="bqView">
              预览数据
              <img src="@/assets/images/ylsj.png" alt="">
            </el-button>
            <!-- <el-button class="otherBtn">
              删除数据
              <img src="@/assets/images/scsj.png" alt="">
            </el-button> -->
          </div>
        </template>
        <template slot="operate" slot-scope="scope">
          <el-button type="text" size="small" @click="labelDataEdit(scope.row.id)">编辑</el-button>
          <el-button type="text" style="color: #f56c6c;" size="small" @click="labelDataDel(scope.row.id)">删除</el-button>
          <el-button type="text" size="small">查看</el-button>
        </template>
      </myTableSearch>
    </div>
    <labelType :isDrawer.sync="isDrawer" ref="labelType"></labelType>
    <labelData :isDrawer.sync="isDataDrawer" ref="labelData"></labelData>

    <!-- 标签预览 -->
    <bqSelect ref="bqSelectRef" v-if="isSelectBq" :isDialog="isSelectBq" :bqLxCode="bqLxCode" :isView="true" @handleClose="isSelectBq=false"></bqSelect>
  </div>
</template>

<script>
import {bqlxTree,bqPage,bqlxDel,bqDel} from "@/api/bqgl.js";
import messageTool from "@/utils/messageUtils.js"
import labelType from "./components/labelType.vue";
import labelData from "./components/labelData.vue";
import bqSelect from './components/bqSelect/bqSelect.vue'
export default {
  components:{
    labelType,
    labelData,
    bqSelect,
  },
  data() {
    return {
      isSelectBq:false,
      typeName: '',
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      formData: [
        {
          label: '标签名称',
          type: 'input',
          key: 'bqLabel',
        },
        {
          label: '状态',
          type: 'select',
          key: 'state',
          data: []
        },
      ],
      tableLabel: [
        {
          prop: 'bqValue',
          label: '标签值',
        },
        {
          prop: 'bqLabel',
          label: '标签名称',
        },
        {
          prop: 'dbTable',
          label: '业务表',
        },
        {
          prop: 'state',
          label: '状态',
          formatter:this.formatState
        },
        {
          prop: 'sort',
          label: '排序',
        },
        {
          prop: 'notes',
          label: '备注',
        },
      ],
      tableData: [
        {
          bqz: '1',
          bqmc: '四省藏区',
          ywb: 'T_SXZQ',
          zt: '正常',
          bz:''
        },
      ],
      isDrawer:false,
      labelType:[],
      isDataDrawer:false,
      bqLxId:null,
      bqLxCode:null,
      stateOptions:[],
    };
  },
  mounted() {
    this.getLabelType();
    this.getState();
  },
  methods: {
    // 标签预览
    bqView(){
      if(this.bqLxCode){
        this.isSelectBq=true;
      }else{
        this.$message.warning('请选择要预览数据的标签！')
      }
    },
    getList(e){
      return bqPage(e);
    },
    labelTypeAdd(){
      this.isDrawer = true;
    },
    typeSearch(){
      this.getLabelType();
    },
    // 标签类型树
    getLabelType(){
      bqlxTree({params:{name:this.typeName}}).then(res=>{
        if(res && res.code==200 && res.data){
          this.labelType = res.data;
        }
      })
    },
    labelDataAdd(){
      if(this.bqLxId && this.bqLxCode){
        this.isDataDrawer = true;
        this.$refs.labelData.initForm(this.bqLxId, this.bqLxCode);
      }else{
        this.msgWarning("请选择标签类型");
      }
    },
    // 修改类型
    labelTypeEdit(data){
      this.isDrawer=true;
      this.$refs.labelType.getDetail(data.id);
    },
    // 删除类型
    labelTypeDel(data){
      let that = this
      messageTool.openConfirm('是否确认删除该标签类型吗?', 'warning', () => {
        bqlxDel({id:data.id}).then(res=>{
          if(res && res.code==200){
            that.getLabelType();
          }
        })
      }, () => {})
    },
    formatState(e){
      return this.selectDictLabel(this.stateOptions,e.state);
    },
    // 标签编辑
    labelDataEdit(id){
      this.isDataDrawer= true;
      this.$refs.labelData.getDetail(id);
    },
    // 刷新列表
    refreshList(){
      if(this.$refs.myTableSearch){
        this.$refs.myTableSearch.initTableData({'bqLxId':this.bqLxId});
      }
    },
    labelDataDel(id){
      let that = this
      messageTool.openConfirm('是否确认删除该标签数据吗?', 'warning', () => {
        bqDel({id}).then(res=>{
          if(res && res.code==200){
            that.refreshList();
          }
        })
      }, () => {})
    },
    getNode(node, data) {
      this.bqLxCode=data.code;
      this.bqLxId=data.id;
      this.$refs.myTableSearch.initTableData({
        ['bqLxId']:data.id
      });
    },
    nodeClick(data){
      this.bqLxCode=data.code;
      this.bqLxId=data.id;
      this.$refs.myTableSearch.initTableData({
        ['bqLxId']:data.id
      });
    },
    getState(){
      this.getDicts("bq_xx_zt").then(res=>{
        if(res && res.code==200 && res.data){
          this.formData[1].data=res.data;
          this.stateOptions=res.data;
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.bqgl {
  font-family: OPPOSans;
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 30px;
  background: rgba(247, 248, 252, 1);
  .left {
    padding: 12px 16px;
    min-width: 312px;
    background: #fff;
    border-radius: 5px;
    overflow-y: hidden;
    display: flex;
    flex-flow: column;

    .searchInput {
      margin-bottom: 24px;
      display: flex;
      margin-top: 16px;
      border-radius: 5px;
      background: rgba(243, 246, 253, 1);
      /deep/.el-input__inner {
        border-radius: 5px 0px 0px 5px;
        border-right: none;
        background: rgba(243, 246, 253, 1);
        color: rgba(42, 51, 71, 1);
        border: none;
        padding-left: 46px;
      }
      /deep/.el-input__prefix{
        display: flex;
        align-items: center;
      }
      .el-input__icon{
        // color: rgba(42, 51, 71, 1);
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin-left: 10px;
      }
      /deep/.el-button {
        border-radius: 0px 5px 5px 0px;
        background: rgba(12, 123, 242, 1);
      }
    }
    .custom-tree-node {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .customTreeNodeLeft{
        flex: 1;
        display: flex;
        align-items: center;
      }
      .oneLevel {
        color: rgba(42, 51, 71, 1);    
        font-weight: bold;
        font-size: 14px;
      }
      .otherLevel {
        color: rgba(107, 120, 133, 1);
        font-weight: 500;
        font-size: 14px;
      }
      .iconTree {
        width: 24px;
        height: 24px;
        line-height: 24px;
        margin-right: 8px;
        // padding: 6px;
        box-sizing: border-box;
      }
    }
    .labelTree{
      flex: 1;
      overflow: auto;
    }
    /deep/.el-icon-caret-right{
      color: rgba(97, 106, 121, 1);
      font-size: 14px;
    }
    /deep/.el-tree-node__expand-icon.is-leaf{
      color: transparent!important;
    }
    /deep/.el-tree-node{
      margin-bottom: 10px;
      .el-tree-node__children{
        margin-top: 10px;
        /deep/.el-tree-node{
          color: rgba(107, 120, 133, 1);
          font-family: OPPOSans;
          font-weight: 500;
          font-size: 14px;
        }
        /deep/.el-tree-node:last-child{
          margin-bottom: 0px;
        }
      }
    }
    /deep/.el-tree-node.is-current{
      .el-tree-node__content{
        background: rgba(12, 123, 242, 0.10);
      }
      .el-tree-node__children{
        .el-tree-node{
          .el-tree-node__content{
            background: transparent;
          }
        }
      }
    }
    /deep/.is-expanded{
      margin-bottom: 0px;
    }
  }
  .right {
    margin-left: 16px;
    flex: 1;
    padding: 12px 16px;
    background: #fff;
    border-radius: 5px;
    display: flex;
    flex-flow: column;
    overflow-x: hidden;
    /deep/.myTableSearch{
      padding: 0;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner, /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background: rgba(99, 217, 181, 1);
      border-color:rgba(99, 217, 181, 1) ;
    }
    .toolBtn{
      /deep/.el-button{
        padding: 6px 14px;
        span{
          display: flex;
          align-items: center;
          img{
            width: 24px;
            height: 24px;
            margin-left: 2px;
          }
        }
      }
      .otherBtn{
        border-radius: 4px;
        border: 1px solid rgba(12, 123, 242, 1);
        box-sizing: border-box;
        background: rgba(252, 252, 252, 1);
        color: rgba(12, 123, 242, 1);
        font-family: OPPOSans;
        font-weight: 500;
        font-size: 14px;
      }
    }
  }

}
</style>
<style lang="scss">
.labelPopover{
  width: 160px!important;
  padding: 8px 12px;
  .moreOperate{
    .treeMoreOperateItem {
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 5px 0px;
      img {
          margin-right: 10px;
          width: 24px;
          height: 24px;
      }
      span {
          color: #616a79;
          font-weight: 500;
          font-size: 12px;
      }
  }
  }
}
  
</style>